import "@/App.css";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { currentSite } from "@/lib/site";
import TeaserPage from "@/components/world1/TeaserPage";
import LogPage from "@/components/world1/LogPage";
import RadioPage from "@/components/world1/RadioPage";
import CipherPage from "@/components/world1/CipherPage";
import DeniedPage from "@/components/world1/DeniedPage";
import SignalPage from "@/components/world1/SignalPage";
import LegalPage from "@/components/world1/LegalPage";
import SharePage from "@/components/world1/SharePage";
import DevIndex from "@/components/world1/DevIndex";
import AdminApp from "@/components/admin/AdminApp";
import HelpersApp from "@/components/helpers/HelpersApp";

function SiteHome() {
  const site = currentSite();
  if (site.kind === "redirect") {
    window.location.replace(`https://333sos.com${window.location.pathname}${window.location.search}`);
    return null;
  }
  const pages = { teaser: TeaserPage, log: LogPage, radio: RadioPage, cipher: CipherPage, denied: DeniedPage, index: DevIndex };
  const Page = pages[site.kind] || DeniedPage;
  return <Page site={site} />;
}

function SlugRoute() {
  const { slug } = useParams();
  const site = currentSite();
  const adminHost = site.domain === "333sos.com" || site.dev;
  if (slug.startsWith("ops-") && adminHost) return <AdminApp slug={slug} />;
  return <DeniedPage site={site} />;
}

function App() {
  if (currentSite().kind === "helpers" && !window.location.pathname.startsWith("/ops-")) return <HelpersApp />;
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SiteHome />} />
        <Route path="/signal/:token" element={<SignalPage />} />
        <Route path="/s/:id" element={<SharePage />} />
        <Route path="/privacy" element={<LegalPage doc="privacy" />} />
        <Route path="/terms" element={<LegalPage doc="terms" />} />
        <Route path="/:slug" element={<SlugRoute />} />
        <Route path="*" element={<DeniedPage />} />
      </Routes>
      <Toaster theme="dark" position="top-center" />
    </BrowserRouter>
  );
}

export default App;
